function q(o, v, z = false) {
    typeof o == "string" && (o = o.replace(".", ""));
    let d = "";
    const m = /\{\{\s*(\w+)\s*\}\}/,
        g = v || "${{amount}}";
    function f(e, n) {
        return typeof e > "u" ? n : e;
    }
    function t(e, n, c, p) {
        if (((n = f(n, 2)), (c = f(c, ",")), (p = f(p, ".")), isNaN(e) || e == null)) return 0;
        e = (e / 100).toFixed(n);
        const r = e.split("."),
            y = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + c),
            h = r[1] ? p + r[1] : "";
        return y + h;
    }
    switch (g.match(m)[1]) {
        case "amount":
            d = t(o, 2);
            break;
        case "amount_no_decimals":
            d = t(o, 0);
            break;
        case "amount_with_comma_separator":
            d = t(o, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            d = t(o, 0, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            d = t(o, 2, "'", ".");
            break;
    }
    if(z) return d;
    return g.replace(m, d);
}
(function () {
    var z = false;
    function o(t, e, n) {
        if (t != null) return (t.innerHTML = '<span class="money">' + q(e, n,z) + "</span>");
    }
    function v(t, e) {
        return t.sellingPlans.find((n) => n.id === Number(e));
    }
    function d(t) {
        let e = t.querySelector('input[name="selling_plan"]');
        return e || ((e = document.createElement("input")), (e.type = "hidden"), (e.name = "selling_plan"), t.append(e)), e;
    }
    function m(t, e, n) {
        const c = Array.from(document.querySelectorAll('form[action$="/cart/add"]')),
            p = c.map(d),
            r = document.querySelector("#juo-subscription-widget");
            
        function w() {
            return r.querySelector("input[type=radio]:checked").value;
        }
        function E() {
            return w() === "onetime" ? "" : r.querySelector('.rc-option--active [part="select"]').value;
        }
        function L() {
            const a = E();
            p.forEach((i) => {
                i.value = a;
            });
        }
        function P() {
            const i = new URL(window.location.href).searchParams.get("variant") || e;
            return t.find(({ id: s }) => s == i) || t.find(Boolean);
        }
        function b(l,a = [], i) {
            if (l.dataset.activeVariant === String(i)) return;
            let s = "";
            if (
                (a.forEach((u) => {
                    s += `<option value="${u.id}">${u.name}</option>`;
                }),
                (l.innerHTML = s),
                a.length === 0)
            ) {
                l.value = "";
                return;
            }
            (l.dataset.activeVariant = i), (l.value = (l == null ? void 0 : l.children[0]).value), L();
        }
        function M(a, i) {
            c.forEach((s) => {
                const u = s.querySelector(".price-list .price:not(.price--compare)");
                u && (u.classList.contains("recharge-inner-most-price") || u.classList.add("recharge-inner-most-price"), (u.textContent = q(a, i)));
            });
        }
        function k() {
            r.querySelector(".rc_widget__option.rc-option--active").classList.remove('rc-option--active');
            r.querySelector("input[type=radio]:checked").closest('.rc_widget__option').classList.add('rc-option--active');
            r.querySelectorAll('.rc-option__onetime').forEach(r => {
                const h = r.querySelector('[part="price price--base"]');
                const a = t.find(({ id: s }) => s == r.querySelector('[name="variant"]').value) || P() || t.find(Boolean);
                o(h, a.price, n)
            })
            r.querySelectorAll('.rc-option__subsave').forEach(r => {
                const y = r.querySelector('[part="subscription-price"]'),
                S = r.querySelector('[part="compare-price"]'),
                l = r.querySelector('[part="select"]');
                z = r.classList.contains("juo-remove-curr");
                // const a = P(),
                const a = t.find(({ id: s }) => s == r.querySelector('[name="variant"]').value) || P() || t.find(Boolean),
                    i = v(a, l.value);
                b(l,a.sellingPlans, a.id);
                const s = w(),
                    u = r.querySelector(".rc-selling-plans.rc_widget__option__plans");
                    console.log(t, a, l.value)
                    const discount = 100-Math.floor(i.price/a.comparePrice * 100);
                //const sid = r.querySelector("select").value;
                let bag = 1, month = 1, month_denominator = 1;
                const sp = i.name.match(/\d+/g);
                if(sp) {
                    month = parseInt(sp[0]);
                }
                // if(sid.length){
                //     const sp = r.querySelector(`option[value="${sid}"]`).innerText.match(/\d+/g);
                //     const package = r.querySelector('input[name="manual_package"]').value;
                //     month_denominator = r.querySelector('input[name="two_month"]') == null ? 1 : 2;
                //     if(sp) {
                //         bag = parseInt(sp[0]) / parseInt(package);
                //         month = parseInt(sp[1]);
                //     }
                // }
                //if ((u && (u.style.display = s === "onetime" ? "none" : ""), i == null)) {
                if ((u && i == null)) {
                    r == null || r.classList.add("juo-hidden");
                    return;
                } else r == null || r.classList.remove("juo-hidden");
                o(y, i.price / month, n), M(s === "onetime" ? a.price : i.price, n), i.price < i.comparePrice && a.price !== i.price ? o(S, i.comparePrice, n) : S && (S.innerHTML = "");
                const js = window.juoStrings || {};
                r.querySelector('.juo-total-price').innerText = month == 1 ? '' : (js.totalPerMonths && js.totalPerMonths[month] ? js.totalPerMonths[month].replace('%PRICE%', q(i.price, n)) : `${q(i.price, n)} per ${month} maanden`)
                r.querySelectorAll('[data-label-text-subsave]').forEach(text => text.innerText = (js.translatePlans && sp && js.planName && js.planName[month]) || i.name)
                r.querySelectorAll('.product-price__compare').forEach(text => text.innerText = q(a.comparePrice / month, n, true))
                r.querySelectorAll('.juo-ajax-discount').forEach(text => text.innerText = discount + "%")
                r.querySelectorAll('.juo-ajax-month').forEach(text => text.innerText = (js.everyMonths && js.everyMonths[month]) || (month == 1 ? 'maand' : month + " maanden"))
            })
            
        }
        function _(e) {
            k(),L();
        }
        _(),
            r.addEventListener("change", _);
            // r.querySelector('[part="select"]')?.addEventListener("change", () => {
            //     r.querySelector('input[type=radio][value="subsave"]').click();
            // });
    }
    function g() {
        const t = document.querySelectorAll('form[action$="/cart/add"]'),
            e = new MutationObserver(() => {
                t.forEach((n) => {
                    const c = n.querySelector(".rc-container-wrapper.rc_container_wrapper:not(.juo-custom)");
                    c && c.remove();
                });
            });
        t.forEach((n) => e.observe(n, { attributes: !1, childList: !0, subtree: !1 }));
    }
    function f() {
        if (window.Shopify != null) {
            let t = function () {
                var p;
                const [e, n, c] = JSON.parse(((p = document.getElementById("juo-subscription-widget-data")) == null ? void 0 : p.innerText) ?? "[]");
                m(e, n, c), g();
            };
            document.readyState === "complete" || document.readyState === "interactive" ? t() : document.addEventListener("DOMContentLoaded", t);
        }
    }
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", f) : f();
})();
